<script setup lang="ts">
import DRBtn from "@/components/UI/DRBtn.vue";
import { useGenerateReport } from "@/stores/queries";
import { computed } from "vue";

const props = defineProps<{
  reportId: number;
  reportName?: string;
  hasTemplate: boolean;
}>();

const reportId = computed(() => props.reportId);
const reportName = computed(() => props.reportName);

const { mutateAsync, isPending } = useGenerateReport(reportId, reportName);

const handleClick = () => {
  if (!props.hasTemplate) return;
  mutateAsync();
};
</script>

<template>
  <DRBtn
    class="generate-btn"
    :disabled="!hasTemplate || isPending"
    :label="$t('report:generate.report')"
    icon="bi-download"
    size="lg"
    @click="handleClick"
    :loading="isPending"
  >
  </DRBtn>
</template>

<style lang="scss" scoped>
.generate-btn {
  height: 44px;
  padding: 0 20px;
  font-size: 15px;
}
</style>
